export const yetiServerIP = 'wss://ozark.yetiapi.com/server';
